export default {"src":"/_next/static/media/SETUP_GUIDE.d8981ff9.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};